import { UserPrivateView } from "./view.js?v=1";
import { UserModel } from "./model.js?v=1";
import { UserPrivateAuthController } from "./auth/controller.js?v=1";
import { LoadingLine } from "../../components/loading-line.js?v=1";
import { UserPrivateServiceController } from "./servicios/controller.js?v=1";
import { UserPrivateAccountController } from "./account/controller.js?v=1";
import { UserPrivateProductController } from "./productos/controller.js?v=1";
import { UserPrivateMachineryController } from "./maquinaria/controller.js?v=1";
import { UserPrivateRealStateController } from "./inmuebles/controller.js?v=1";
import { ModalController } from "../../components/modal/controller.js?v=1";
import { UserPrivateViewGenericItems } from "./view-generic-items.js";
import { LoadingDot } from "../../components/loading-dot.js";

// region USER Class
export class UserPrivateController {
  static instance = null;
  static userData = null;

  constructor() {
    if (UserPrivateController.instance) {
      throw new Error("Solo puede haber una instancia de usuario privado.");
    }

    this.buttons = ['productos', 'maquinaria', 'servicios', 'inmuebles', 'account'];
    this.data = null;
    this.view = new UserPrivateView();
    this.model = new UserModel();
    this.auth = new UserPrivateAuthController();
    this.account = new UserPrivateAccountController();
    this.servicios = new UserPrivateServiceController();
    this.productos = new UserPrivateProductController();
    this.maquinaria = new UserPrivateMachineryController();
    this.inmuebles = new UserPrivateRealStateController();
    this.viewGenericItems = new UserPrivateViewGenericItems();
    this.publishModal = null;
    this.loading = LoadingLine.getInstance();


    return new Proxy(this, {
      get: (target, prop) => {
        if (prop == 'userData') {
          return UserPrivateController.userData;
        } else if (typeof target[prop] == 'function') {
          return target[prop].bind(target);
        } else if (typeof target[prop] == 'object') {
          return target[prop];
        }
        return undefined;
      },
      set: (target, prop, value) => {
        if (prop === 'userData') {
          UserPrivateController.userData = value;
        } else {
          target[prop] = value;
        }
        return true;
      }
    });
  }



  checkSession() {
    this.auth.sessionAlive()
      .then(this.init.bind(this))
      .catch(_error => {
        window.localStorage.removeItem('user-data');
        console.log(_error);
        this.auth.view.showLoginInHeader();
        if (window.location.pathname.indexOf('/user') > -1) {
          window.location.href = '/';
        }
      })
  }

  static getInstance() {
    if (!UserPrivateController.instance) {
      UserPrivateController.instance = new UserPrivateController();
    }
    return UserPrivateController.instance;
  }

  init() {
    this.account.clearFields();
    this.auth.model.getSessionData()
      .then(data => {
        UserPrivateController.userData = data;
        this.view.showMenuInHeader(data);

        if (window.location.pathname.indexOf('/user') > -1) {
          this.view.showMainContent(data);
          let subpath = window.location.pathname.match(/^\/user\/(.+)$/);

          if (window.location.pathname == '/user' || window.location.pathname == '/user/') {
            this.router('servicios');
          } else if (subpath && subpath.length > 1) {
            this.router(subpath[1]);
          }
          app.userPrivateController.account.checkSubscription();
        }
      })
      .catch(console.error)
  }

  //#region router
  router(_section) {
    if (window.location.pathname.indexOf('/user') == -1) {
      window.location.href = '/user/' + _section;
      return;
    }

    this.resetButtons();

    if (!document.getElementById('user-content')) {
      window.location.reload();
      return;
    }

    document.getElementById('user-content').innerHTML = LoadingDot.render();

    this.loading.show();

    switch (_section) {
      case 'productos/new':
        this.productos.new();
        this.productos.loadMain();
        break;

      case 'productos':
        this.productos.loadMain();
        break;

      case 'maquinaria/new':
        this.maquinaria.new();
        this.maquinaria.loadMain();
        break;

      case 'maquinaria':
        this.maquinaria.loadMain();
        break;

      case 'inmuebles/new':
        this.inmuebles.new();
        this.inmuebles.loadMain();
        break;

      case 'inmuebles':
        this.inmuebles.loadMain();
        break;

      case 'servicios/new':
        this.servicios.new();
        this.servicios.loadMain();
        break;

      case 'servicios':
        this.servicios.loadMain();
        break;

      case 'account':
        this.account.loadMain(UserPrivateController.userData);
        break;
    }
  }

  //#region router
  async GetInfo(_idcodUser) {
    return await this.auth.getInfoUserFromIdcod(_idcodUser);
  }

  menu(_status) {
    if (_status === true) {
      if (!document.getElementById('user-menu').classList.contains('active')) {
        document.getElementById('user-menu').classList.add('active');
        document.getElementById('user-session').classList.add('active');
      }
    } else if (_status === false) {
      document.getElementById('user-menu').classList.remove('active');
      document.getElementById('user-session').classList.remove('active');
    } else {
      document.getElementById('user-menu').classList.toggle('active');
      document.getElementById('user-session').classList.toggle('active');
    }
  }


  resetButtons() {
    for (let i = 0; i < this.buttons.length; i++) {
      document.getElementById('btn-' + this.buttons[i])?.classList.remove('active');
      document.getElementById('btn-header-' + this.buttons[i])?.classList.remove('active');
    }
  }

  publish() {
    this.auth.sessionAlive()
      .then(() => {
        if (!this.publishModal) {
          this.publishModal = new ModalController('¿Qué necesitás publicar?', this.view.renderPublishModal(), 'publish-modal');
        }
      })
      .catch(() => {
        this.auth.showLogin();
      })
      .finally(() => {

        this.publishModal.show();
      })
  }

  publishAction(_type) {
    switch (_type) {
      case 'producto':
        this.productos.new();
        break;
      case 'inmueble':
        this.inmuebles.new();
        break;
      case 'maquinaria':
        this.maquinaria.new();
        break;
      case 'servicio':
        this.servicios.new();
        break;
    }
    this.publishModal.close();
    setTimeout(() => {
      this.publishModal = null;
    }, 500);
  }

  changePublicationVisibility(_entity, _idcod, _status) {
    let titleStatus = document.getElementsByClassName('title-status');
    if (titleStatus.length == 1) {
      let html = '';
      if (titleStatus[0].innerHTML.indexOf('Oculto') > -1) {
        html = this.view.renderPublishButton('1');
      } else {
        html = this.view.renderPublishButton('0');
      }
      setTimeout(() => {
        titleStatus[0].innerHTML = html;
      }, 200, html)
    }
  }
}
